
import {
    defineComponent, PropType,
} from '@vue/composition-api';

export default defineComponent({
    name: 'Tooltip',
    props: {
        typeTooltip: {
            type: String as PropType<'white' | 'black'>,
            default: 'white',
        },
    },
});
